<template>
  <a-form-item
    :label="label ?? $t('global.phone.title')"
    :required="required"
    :extra="extra"
    :validate-status="validateStatus"
    :has-feedback="hasFeedback">
    <a-input
      type="tel"
      :value="value ?? ''"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      @input="onInput" />
  </a-form-item>
</template>

<script setup>
import { computed } from "vue"

import { isValidPhoneNumber, normalizePhoneNumberInput } from "./PhoneNumber"

const props = defineProps({
  value: { type: String, default: null },
  label: { type: String, default: null },
  required: { type: Boolean, default: false },
  extra: { type: String, default: null },
  placeholder: { type: String, default: "-" },
  showValidation: { type: Boolean, default: true },
  hasFeedback: { type: Boolean, default: true },
  readonly: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
})

const emit = defineEmits(["update:value"])

const validateStatus = computed(() => {
  if (!props.showValidation) return ""

  const phone = String(props.value ?? "")
  if (!phone || phone === "+") return ""
  return isValidPhoneNumber(phone) ? "success" : "error"
})

const onInput = (event) => {
  const next = normalizePhoneNumberInput(event?.target?.value)
  emit("update:value", next)
}
</script>

